import type { ModeDetails, SuggestionType } from "../types/suggest-correction";

const suggestCorrection = async (
	_itemId: number,
	_suggestion: SuggestionType,
	_modeDetails?: ModeDetails,
): Promise<boolean | unknown> => {
	return { suggestCorrection: true };
};

export default suggestCorrection;
